import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { REHYDRATE } from 'redux-persist';

export interface UiState {
  sidebarCollapsed: boolean;
  globalLoadingCount: number;
}

const initialState: UiState = {
  sidebarCollapsed: false,
  globalLoadingCount: 0,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    incrementGlobalLoading(state) {
      state.globalLoadingCount += 1;
    },
    decrementGlobalLoading(state) {
      state.globalLoadingCount = Math.max(0, state.globalLoadingCount - 1);
    },
    resetGlobalLoading(state) {
      state.globalLoadingCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state) => {
      state.globalLoadingCount = 0;
    });
  },
});

export const {
  setSidebarCollapsed,
  toggleSidebar,
  incrementGlobalLoading,
  decrementGlobalLoading,
  resetGlobalLoading,
} = uiSlice.actions;
export default uiSlice.reducer;
